<template>
  <div class="aside-attr" @click.stop>
    <div class="aside-attr-title">文字</div>
    <div class="aside-attr-body text-panel">
      <section class="section2">
        <template>
          <p class="section-title">字体</p>
          <div class="font-tools">
            <el-select
              v-if="$store.getters['app/isAdmin']"
              class="font-family"
              popper-class="font-family-options-wrap"
              v-model="modelFontFamily"
              @change="onModelFontFamilyChange"
              @click.stop
            >
              <el-option
                v-for="(item, index) in fontList"
                :value="item.psName"
                :key="index"
                :label="`${item.fontFamily}${
                  item.weight ? `-${item.weight}` : ''
                }`"
              >
                <el-tooltip
                  v-if="!item.eotUrl && currentTemplate.type === 'PPT'"
                  effect="dark"
                  content="建议选择其他字体，该字体不支持PPT导出使用"
                  placement="top-start"
                >
                  <div>{{ item.psName }}</div>
                </el-tooltip>
                <img v-else :src="item.preview" height="18" />
                <!-- <div v-else>{{item.alias}}</div> -->
              </el-option>
              <div slot="empty"></div>
            </el-select>
            <el-input-number
              class="font-size"
              v-model="modelFontSize"
              :min="12"
              controls-position="right"
              @change="onFontSizeChange"
            ></el-input-number>
          </div>
        </template>
        <div class="color-section tp-top">
          <label>颜色</label>
          <div class="color-box">
            <div class="color-block">
              <el-popover
                v-if="predefineColors.length"
                placement="bottom"
                trigger="hover"
                width="200"
              >
                <div>
                  <ul class="text-panel-color-list">
                    <li
                      v-for="(item, index) in predefineColors"
                      @click="onColorItemClick(item)"
                      :key="index"
                      :style="{ backgroundColor: item }"
                    ></li>
                  </ul>
                </div>
                <span
                  slot="reference"
                  class="color-shortcut"
                  :style="{ backgroundColor: modelTextColor }"
                >
                </span>
              </el-popover>
              <span
                v-else
                class="color-shortcut"
                :style="{ backgroundColor: modelTextColor }"
              >
              </span>
              <span class="color-icon" @click="onColorClick"
                ><i style="color: #000000" class="myico-colors"></i
              ></span>
              <el-color-picker
                ref="textColorRef"
                class="no-border"
                v-model="modelTextColor"
                @active-change="setTextColor"
                show-alpha
                popper-class="picker-no-button picker-no-border"
              >
              </el-color-picker>
            </div>
            <img
              src="img/xiguan.svg"
              class="xiguan-icon"
              title="取色"
              @click="openTheColor"
            />
          </div>
        </div>
        <div class="css-tools tp-top">
          <div
            @click.stop="setTextWeight"
            class="css-item"
            :class="{ active: modelFontWeight === 'bold' }"
            title="加粗"
          >
            <span>B</span><br />
            <span class="desc">加粗</span>
          </div>
          <span class="divide-line"></span>
          <div
            @click.stop="setTextUnderline"
            class="css-item"
            :class="{ active: modelUnderline }"
            title="下划线"
          >
            <span class="underline">U</span><br />
            <span class="desc">下划线</span>
          </div>
          <span class="divide-line"></span>
          <div
            @click.stop="setTextDelline"
            class="css-item"
            :class="{ active: modelDelline }"
            title="删除线"
          >
            <span class="delline">D</span><br />
            <span class="desc">删除线</span>
          </div>
          <span class="divide-line"></span>
          <div
            @click.stop="showBgSet"
            class="css-item"
            :class="{ active: bgSet.color }"
            title="底纹"
          >
            <span>D</span><br />
            <span class="desc">加底色</span>
          </div>
        </div>
        <div class="bg-set-box" v-show="bgVisible">
          <div class="bsb-item">
            <label>设定高度</label>
            <el-input
              style="width: 140px"
              v-model="bgSet.height"
              :placeholder="placeholderJson.height"
              @focus.stop
            ></el-input>
          </div>
          <div class="bsb-item">
            <label>设定底部距离</label>
            <el-input
              style="width: 140px"
              v-model="bgSet.bottom"
              :placeholder="placeholderJson.bottom"
              @focus.stop
            ></el-input>
          </div>
          <div class="bsb-item">
            <label>颜色</label>
            <div class="bg-attr">
              <el-color-picker
                popper-class="picker-no-button"
                color-format="rgb"
                :show-alpha="false"
                v-model="bgSet.color"
                @active-change="onBgColorChange"
              ></el-color-picker>
              <el-input
                style="width: 105px"
                v-model="bgSet.color"
                :placeholder="placeholderJson.color"
                @focus.stop
              ></el-input>
            </div>
          </div>
          <div class="bsb-btn-box">
            <el-button type="primary" size="mini" @click="setTextBgColor"
              >设置</el-button
            >
            <el-button type="primary" size="mini" @click="clearTextBgColor"
              >清除</el-button
            >
          </div>
        </div>
      </section>
      <section class="section-last">
        <p class="section-title">
          <el-checkbox v-model="textShadow" key="3" @change="onTextShadowCheck"
            >阴影</el-checkbox
          >
        </p>
        <text-shadow
          v-model="modelTextShadow"
          @change="onTextShadowChange"
        ></text-shadow>
      </section>
    </div>
    <color-tool-modal
      v-model="theColorVisible"
      :url="imgUrl"
      @change="onColorChange"
    ></color-tool-modal>
  </div>
</template>
<script>
import { text_bg_set, minus_plus } from '@/const.js'
import TUtil from '../TUtil'
import colorToolModal from '../../components/color-tool'
import util from '@/util.js'
import textShadow from '../../components/text-shadow'

export default {
  components: { colorToolModal, textShadow },
  props: {
    currentTemplate: Object,
    selectedOptionItem: Object,
    defaultBg: Object,
    imgUrl: String,
    onSelectionMouseup: Function,
    selectionEvent: Object
  },
  data () {
    return {
      selectedModuleGroupItemIndex: null,
      bgVisible: false,
      bgSet: Object.assign({}, text_bg_set),
      modelFontSize: 0,
      modelUnderline: '',
      modelDelline: '',
      modelFontWeight: '',
      modelTextColor: '',
      placeholderJson: Object.assign({}, text_bg_set),
      theColorVisible: false, //取色器
      modelFontFamily: null,
      modelTextShadow: null,
      predefineColors: [],
      textShadow: false
    }
  },
  computed: {
    fontList () {
      return this.$store.state.app.projectFontList
    }
  },
  watch: {
    imgUrl () {
      this.theColorVisible = true
    },
    'selectedOptionItem.colorValueList' (textColors) {
      this.setDefaultColors(textColors)
    }
  },
  mounted () {},
  methods: {
    _initTextPanel (textCssObj) {
      this.setTextCss(textCssObj)
      let textBg = textCssObj.textBg
      if (textBg && textBg.color) {
        this.bgSet = Object.assign({}, textBg)
        this.bgVisible = true
      } else {
        this.placeholderJson = Object.assign({}, text_bg_set, this.defaultBg)
        this.bgSet = Object.assign({}, text_bg_set)
        if (!this.bgColor) {
          this.bgSet.color = this.placeholderJson.color
        }
        this.bgVisible = false
      }
    },
    setDefaultColors (textColors) {
      let colorArray = []
      if (textColors && textColors.length > 0) {
        colorArray = textColors
      }
      let colors = this.currentTemplate.json.defaultTextColors
      if (colors) {
        colors = colors.replace(/，/g, ',')
        colors = colors.replace(/ /g, '')
        colorArray = colorArray.concat(colors.split(','))
      }
      this.predefineColors = colorArray
    },
    setTextCss (textCssObj) {
      let fontSize = textCssObj['font-size']
      this.modelFontSize = parseInt(fontSize ? fontSize.replace('px', '') : 0)
      this.modelFontFamily = textCssObj['font-family']
      let line = textCssObj['text-decoration']
      this.modelUnderline = line === 'underline' ? line : ''
      this.modelDelline = line === 'line-through' ? line : ''
      this.modelFontWeight = textCssObj['font-weight']
      this.modelTextColor = textCssObj['color'].toLowerCase()
      this.modelTextShadow = textCssObj['text-shadow']
      this.textShadow = this.modelTextShadow ? true : false
    },
    setTextWeight () {
      this.bgVisible = false
      this.modelFontWeight = this.modelFontWeight === 'bold' ? 'normal' : 'bold'
      this.$emit('addCache')
      this.setTextStyle('font-weight', this.modelFontWeight)
    },
    setTextColor (v) {
      this.bgVisible = false
      this.$emit('addCache')
      this.setTextStyle('color', v)
      this.modelTextColor = v
    },
    onColorChange (v) {
      this.setTextColor(v)
    },
    setTextUnderline () {
      this.bgVisible = false
      this.modelUnderline =
        this.modelUnderline === 'underline' ? '' : 'underline'
      this.$emit('addCache')
      this.setTextStyle('text-decoration', this.modelUnderline)
    },
    setTextDelline () {
      this.modelDelline =
        this.modelDelline === 'line-through' ? '' : 'line-through'
      this.$emit('addCache')
      this.setTextStyle('text-decoration', this.modelDelline)
    },
    showBgSet () {
      this.bgVisible = true
    },
    clearTextBgColor () {
      let focusCssTextData = this.$store.state.templateGroup.focusCssText
      if (focusCssTextData && focusCssTextData.textBg) {
        Object.assign(focusCssTextData.textBg, text_bg_set)
      }
      Object.assign(this.bgSet, text_bg_set)
      this.$emit('addCache')
      this.setTextStyle('textBg', this.bgSet)
      this.bgVisible = false
    },
    setTextBgColor () {
      let focusCssTextData = this.$store.state.templateGroup.focusCssText
      if (focusCssTextData && focusCssTextData.textBg) {
        Object.assign(focusCssTextData.textBg, this.bgSet)
      }
      this.setDefaultForNull()
      this.$emit('addCache')
      this.setTextStyle('textBg', this.bgSet)
      this.bgVisible = false
    },
    setDefaultForNull () {
      if (!this.bgSet.color) {
        this.bgSet.color = this.placeholderJson.color
      }
      let height = this.bgSet.height
      if (height !== 0 && !height) {
        this.bgSet.height = this.placeholderJson.height
      }
      let bottom = this.bgSet.bottom
      if (bottom !== 0 && !bottom) {
        this.bgSet.bottom = this.placeholderJson.bottom
      }
    },
    onFontSizeChange (value) {
      this.$emit('addCache')
      let size = value + 'px'
      this.setTextStyle('font-size', size)
    },
    onTextShadowChange (v) {
      this.$emit('addCache')
      this.setTextStyle('text-shadow', v)
      this.textShadow = v ? true : false
    },
    onTextShadowCheck (v) {
      if (!v) {
        this.modelTextShadow = ''
        this.setTextStyle('text-shadow', null)
      }
    },
    onBgColorChange (color) {
      this.bgSet.color = color
    },
    onHideText (value) {
      this.$emit('addCache')
      let textHeight = null
      let item = this.selectedOptionItem
      if (value) {
        textHeight = document.querySelector(
          '.tpl-group-edit .item-active'
        ).offsetHeight
        item.height = textHeight
      } else {
        textHeight = item.height
      }
      let minusOrPlus = value ? minus_plus.minus : minus_plus.plus
      let editorObj = this.currentTemplate.json
      TUtil.moveItem(editorObj, item, minusOrPlus, textHeight)
    },
    openTheColor () {
      if (this.imgUrl) {
        this.theColorVisible = true
      } else {
        this.$emit('generateImg')
      }
    },
    onModelFontFamilyChange (fontName) {
      if (!fontName) {
        return
      }
      let fontUrl = this.fontList.filter(item => {
        return item.psName === fontName
      })[0].url
      util.downloadFont(fontName, fontUrl).then(() => {
        this.setTextStyle('font-family', fontName)
      })
      // console.log('fontname', fontName)
      // this.setTextStyle('font-family', fontName)
    },
    setTextStyle (key, value) {
      let selection = this.selectionEvent
      console.log(0, selection)
      if (!selection) {
        // 快捷键全选时不会触发onSelectionMouseup， 重新获取一次选中文本
        selection = this.onSelectionMouseup()
      }
      let selectedItem = this.$store.state.templateGroup.selectedItem
      let textDom = this.$store.state.templateGroup.selectedTextDom
      // console.log(111, selection, selectedItem, textDom)
      if (
        !selection ||
        !selectedItem ||
        selectedItem.type !== 'text' ||
        !textDom
      ) {
        return
      }
      console.log(333)
      if (selection.type !== 'Range') {
        return
      }
      let dataList = TUtil.getSelectionRangeData(
        this,
        selection,
        textDom,
        text_bg_set,
        key,
        value
      )
      console.log(222, dataList)
      this.$set(selectedItem, 'textStyleList', dataList)
      selectedItem.key = util.getUUID()
      this.$nextTick(() => {
        this.$emit('setSelectionText')
      })
    },
    onColorClick () {
      this.$refs.textColorRef.$el
        .querySelector('.el-color-picker__trigger')
        .click()
    },
    onColorItemClick (color) {
      this.modelTextColor = color
      this.setTextColor(color)
    }
  }
}
</script>
<style lang="scss">
@import './text-panel';
</style>
